import { defineStore } from 'pinia';
import homeService from '@/shared/services/home.service';
import { useAuthStore } from './auth.store';

// Home, the notification centre and Fluid show the same pending dry-weight update,
// so closing it in one place removes it from all of them.
export const useDryWeightUpdateStore = defineStore('dryWeightUpdateStore', {
  state: () => ({
    updates: [],
    requestVersion: 0,
  }),
  getters: {
    // The current unacknowledged prescription returned by the API.
    current: (state) => state.updates[0],
  },
  actions: {
    async load() {
      const auth = useAuthStore();
      const version = auth.authStateVersion;
      const requestVersion = ++this.requestVersion;
      const result = await homeService.getDryWeightUpdate();
      if (version === auth.authStateVersion && this.requestVersion === requestVersion) {
        this.updates = result.dryWeightUpdates;
      }
    },
    remove(itemUnique) {
      this.requestVersion += 1;
      this.updates = this.updates.filter((update) => update.itemUnique !== itemUnique);
    },
    removePrescription(prescriptionItemUnique) {
      // A read started before acknowledgement must not restore the acknowledged card.
      this.requestVersion += 1;
      this.updates = this.updates.filter(
        (update) => update.prescriptionItemUnique !== prescriptionItemUnique,
      );
    },
  },
});
